import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../Common/Table/Table";
import { cards, userCards } from "./../../actions/cards/cards";
import PageHeader from "./../PageHeader";
// import moment from "moment";
import { useHistory, useLocation } from "react-router";
import card_icon from "../../assets/icons/card.png";
import { amountFormat, hasAccess } from "../../utils";
import endpoint from "../../config/Axios";
import { apis } from "../../config/APIs";
import { saveAs } from "file-saver";
import json2csv from "json2csv";
import CardPDF from "./CardPDF";
import { pdf } from "@react-pdf/renderer";
import { getSymbol } from "../../config/helper";

export const status = {
  Activated: "approved",
  Y: "approved",
  COMPLETED: "approved",
  N: "pending_approval",
  "Permanent Hotlist": "rejected",
  "Issued not active": "pending_approval",
  "Generated not issued": "pending_reimbursement",
};

export const statuses = {
  Y: "Completed",
  N: "Pending",
};

const Cards = () => {
  const history = useHistory();
  const cardsResponse = useSelector((state) => state.cards.cards || {});
  const userCardsResponse = useSelector((state) => state.cards.userCards || {});
  const { data: { response: { cards: cardsList = [] } = {} } = {} } =
    cardsResponse;
  const { data: { response: { cards: userCardsList = [] } = {} } = {} } =
    userCardsResponse;
  const dispatch = useDispatch();
  const is_admin = useSelector(
    (state) => state?.auth?.localVariables?.is_admin,
  );
  const [filters, setFilters] = React.useState({
    status: "A",
  });
  const location = useLocation();
  const [page, setPage] = React.useState(1);
  const loading = cardsResponse.loading || userCardsResponse.loading;

  React.useEffect(() => {
    if (is_admin !== "") {
      let obj = {};
      if (location?.state?.non_linked) {
        obj.non_linked = location?.state?.non_linked;
      }
      if (location?.state?.prevStatus) obj.status = location?.state?.status;
      else obj.status = "A";
      setFilters(obj);
      is_admin
        ? dispatch(cards({ non_linked: false, source: "admin", ...obj }))
        : dispatch(userCards({}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [is_admin]);

  const originalColumns = [
    {
      title: "Card number",
      dataIndex: "card_number",
      key: "card_number",
      width: 150,
      render: (text, record) => (
        <div className={`render_common_style status_${record?.status}`}>
          <img src={card_icon} width={25} alt="card" className="mr1" />
          {text?.includes("XXX")
            ? text
                ?.replace(/\w{4}(?=.)/g, "$& ")
                ?.replaceAll("X", "*")
                ?.slice(text?.length - 7)
            : text?.slice(text?.length - 9)}
        </div>
      ),
    },
    {
      title: "CRN",
      dataIndex: "card_reference_no",
      key: "card_reference_no",
      width: 150,
    },
    {
      title: "Employee ID",
      dataIndex: "empid",
      key: "empid",
      width: 150,
      render: (text, record) => (
        <div>{record.employee_details?.employee_id}</div>
      ),
    },
    {
      title: "Employee Name",
      dataIndex: "company_name",
      key: "company_name",
      width: 250,
      render: (text, record) => <div>{record.employee_details?.name}</div>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 250,
      render: (text, record) => <div>{record.employee_details?.email}</div>,
    },
    // {
    //   title: "Transit Queue Wallet",
    //   dataIndex: "data",
    //   key: "data",
    //   width: 150,
    //   render: (text) => <div>{amountFormat(text?.transitQueue)}</div>,
    // },
    // {
    //   title: "Total Balance",
    //   dataIndex: "balance",
    //   key: "balance",
    //   width: 150,
    //   // render: (text, record) => <div>{record?.data?.balance}</div>,
    // },
    // {
    //   title: "Benefits",
    //   dataIndex: "title",
    //   key: "title",
    //   width: 150,
    //   render: (text) => <div>Rs. 15,000</div>,
    // },
    // {
    //   title: "End Date",
    //   dataIndex: "title",
    //   key: "title",
    //   width: 150,
    //   render: (text) => <div>9 Sep'18</div>,
    // },
    {
      title: "Activated On",
      dataIndex: "card_activated_on",
      key: "card_activated_on",
      width: 200,
      // render: (text) => <div>9 Sep'18</div>,
    },
    {
      title: "Card Status",
      dataIndex: "status",
      key: "status",
      width: 250,
      render: (text) => (
        <div className={`status status_${status[text]}`}>
          {text === "Generated not issued" ? "Un-Assigned" : text}
        </div>
      ),
    },
    filters.status === "PHL"
      ? {
          title: "Reason",
          dataIndex: "reason",
          key: "reason",
          render: (text, record) => <div>{record?.data?.cardStatusReason}</div>,
        }
      : {
          title: "KYC Status",
          dataIndex: "kyc_flag",
          key: "kyc_flag",
          width: 150,
          render: (text) => (
            <div className={`status_text_${status[text]}`}>{text}</div>
          ),
        },
  ];

  const firstRow = is_admin ? cardsList?.[0] : userCardsList?.[0]; // Assuming `card_list` is not empty
  if (firstRow && Array.isArray(firstRow.wallets)) {
    const walletColumns = firstRow.wallets.map((wallet) => ({
      title: `${wallet.wallet_name?.toLowerCase()} Wallet`,
      dataIndex: wallet.wallet_name.toLowerCase() + "_wallet", // Optional, can skip if not needed
      key: wallet.wallet_name.toLowerCase() + "_wallet",
      width: 150,
      render: (text, record) => {
        const walletData = record.wallets.find(
          (ele) => ele.wallet_name === wallet.wallet_name,
        );
        return <div>{amountFormat(walletData?.balance) ?? "-"}</div>;
      },
    }));

    // Add wallet columns to the original columns
    // originalColumns.splice(5, 0, ...walletColumns);
  }

  const [columns, setColumns] = useState(originalColumns);
  useEffect(() => {
    if (!is_admin) {
      setColumns(
        originalColumns?.filter(
          (ele) => ele?.title !== "Email" && ele?.title !== "Employee ID",
        ),
      );
    } else {
      setColumns(originalColumns);
    }
  }, [is_admin]);

  const downloadPdf = async (fileName, cards) => {
    if (cards.length > 0) {
      const blob = await pdf(<CardPDF data={cards || []} />).toBlob();
      saveAs(blob, fileName);
    }
  };

  const handleRowClick = (evt, record) => {
    evt.preventDefault();

    // prefer record.imageUrl, then record.data.imageUrl, then fallback file
    const pickedImage = record?.data?.imageUrl;

    // compute orientation immediately
    const img = new Image();
    img.onload = () => {
      const isVertical = img.height > img.width;
      if (record && !is_admin) {
        history.push({
          pathname: `/card-details/${record.id}`,
          state: {
            cardData: record,
            status: filters.status,
            non_linked: filters.non_linked,
            isVertical,
            selectedImageUrl: pickedImage,
          },
        });
      }
    };
    img.onerror = () => {
      if (record && !is_admin) {
        history.push({
          pathname: `/card-details/${record.id}`,
          state: {
            cardData: record,
            status: filters.status,
            non_linked: filters.non_linked,
            isVertical: null,
            selectedImageUrl: pickedImage,
          },
        });
      }
    };

    // start loading (triggers onload/onerror above)
    img.src = pickedImage;
  };

  const handleFilter = (value) => {
    if (value === "true") {
      is_admin
        ? dispatch(cards({ status: true, source: "admin" }))
        : dispatch(userCards({ status: true }));
    } else {
      if (typeof value === "object") {
        is_admin
          ? dispatch(cards({ ...value, source: "admin" }))
          : dispatch(userCards(value));

        setFilters({
          ...value,
          search: filters.search,
          source: "admin",
        });
      } else {
        is_admin
          ? dispatch(cards({ status: value, source: "admin" }))
          : dispatch(userCards({ status: value }));

        setFilters({ status: value });
      }
    }
    setPage(1);
  };

  return (
    <>
      {/* <PDFDownloadLink document={<CardPDF data={cardsList || []} />}>
        {({ blob, url, loading, error }) =>
          loading ? '' : setpdfURL(url)
        }
      </PDFDownloadLink> */}
      <div className="heading-div">
        <PageHeader
          title={`Cards`}
          navigation={{
            Home:
              hasAccess("dashboard", "read") || hasAccess("dashboard", "write")
                ? "/dashboard"
                : "",
            Cards: "/cards/",
          }}
        />
      </div>
      <Table
        rowKey="id"
        className={`tableStyled ${is_admin ? "admin cards" : ""}`}
        columns={columns}
        data={is_admin ? cardsList : userCardsList}
        isTopFilter={is_admin}
        isMore={is_admin}
        activeButton={filters.status}
        handleRowClick={handleRowClick}
        placeholder={"Search By CRN, Name"}
        handleSearch={(value) => {
          is_admin
            ? dispatch(cards({ ...filters, search: value, source: "admin" }))
            : dispatch(userCards({ ...filters, search: value }));
          setFilters({
            ...filters,
            search: value,
            source: "admin",
          });
          setPage(1);
        }}
        handleFilter={handleFilter}
        hasExport={is_admin}
        onExport={(value) => {
          endpoint
            .get(
              apis.cards,
              {
                params: {
                  ...filters,
                  source: "admin",
                  download: true,
                },
              },
              { skipSuccessMessage: true },
            )
            .then((res) => {
              let cards = res?.data?.response?.cards;
              if (value === "PDF") {
                downloadPdf("Cards.pdf", cards);
              } else if (value === "CSV") {
                if (cards?.length > 0) {
                  cards?.forEach((card) => {
                    card.employee_name = card.employee_details?.name;
                    card.employee_id = card.employee_details?.employee_id;
                    card.email = card.employee_details?.email;
                    Object.keys(card)?.forEach((key) => {
                      if (key?.includes("balance")) {
                        card[key] = getSymbol() + " " + amountFormat(card[key]);
                        card.data.walletNameAndBalance?.forEach((itm) => {
                          card[
                            "balance" + "_" + itm.walletName?.toLowerCase()
                          ] = getSymbol() + " " + amountFormat(itm.balance);
                        });
                      }
                    });

                    delete card.data;
                    delete card.employee_details;
                    delete card.wallets;
                    delete card.id;
                    delete card.expense_wallet;
                    delete card.reimburse_wallet;
                  });
                  let csv = json2csv.parse(cards, {
                    fields: [
                      "card_number",
                      "card_reference_no",
                      "employee_id",
                      "employee_name",
                      "email",
                      "card_activated_on",
                      "status",
                      "kyc_flag",
                      "mobile_no",
                      "correspondence_mobile",
                      "balance",
                      "balance_fuel",
                      "balance_gift",
                      "balance_expense",
                      "balance_reimburse",
                      "balance_transit",
                      "balance_meal",
                      "company_name",
                      "replacement_request_placed_on",
                      "replacement_request_placed",
                      "tenant_id",
                    ],
                  });
                  var blob = new Blob([csv], {
                    type: "text/csv;charset=utf-8",
                  });
                  saveAs(blob, "Cards.csv");
                }
              }
            });
        }}
        pagination={{
          total: cardsResponse?.data?.total_records || 0,
          current: page,
          onChange: (pagee) => {
            is_admin
              ? dispatch(cards({ page: pagee, source: "admin", ...filters }))
              : dispatch(userCards({ page: pagee, ...filters }));
            setPage(pagee);
          },
        }}
        scroll={{ x: "max-content" }}
        topFilters={[
          { label: "All Cards", filter: "", isActive: filters.status === "" },
          {
            label: "Active",
            filter: { status: "A", non_linked: false },
            isActive: filters.status === "A",
          },
          {
            label: "Not Activated",
            filter: { status: "INA", non_linked: false },
            isActive: filters.status === "INA",
          },
          {
            label: "Permanant Hotlisted",
            filter: { status: "PHL", non_linked: false },
            isActive: filters.status === "PHL",
          },
          {
            label: "Temporary Hotlisted",
            filter: { status: "THL", non_linked: false },
            isActive: filters.status === "THL",
          },
          {
            label: "Un-Assigned",
            filter: { non_linked: true },
            isActive: filters.non_linked,
          },
        ]}
        loading={loading}
      />
    </>
  );
};

export default Cards;
